
import * as angular from "angular";
import { ColourService } from "@services/colour.service";
import { JourneyService } from "@services/journey.service";
import "./listogram.scss";

export interface ISummaryHistogram<T> {
    id: number;
    description: string;
    color?: string;
    count: number;
    duration: number;
    percentage: number;

    object?: T;
}

interface IListogramComponentBindings {
    title: string;
    timePeriodTitle: string;
    list: ISummaryHistogram<any>[];
    maxResults: number;
    loading: boolean;
}

class ListogramComponentController implements angular.IComponentController, IListogramComponentBindings {
    title: string;
    timePeriodTitle: string;
    list: ISummaryHistogram<any>[];
    displayList: ISummaryHistogram<any>[];
    maxResults: number;
    loading: boolean;

    static $inject = ["journeyService", "colourService"];

    constructor(
        private readonly journeyService: JourneyService,
        private readonly colourService: ColourService) {
    }

    $onInit() {
        this.maxResults = this.maxResults || 3;
        //this.loading = true;
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        if (onChangesObj["list"]) {
            this.updateColours();
        }
    }

    private updateColours() {
        var listToDisplay = this.list.sort((a, b) => {
            return b.duration - a.duration;
        });

        this.displayList = [];
        listToDisplay.forEach(item => {

            if (item.percentage > 1 && this.displayList.length < this.maxResults) {
                this.displayList.push(item);
            }
        });

        this.displayList.forEach((item, i) => {
            item.color = this.colourService.getColour(i, true).solidColour;
        });
    }
}

export class ListogramComponent implements angular.IComponentOptions {
    bindings: any;
    template: string;
    controller: any;

    constructor() {
        this.bindings = {
            title: "@",
            timePeriodTitle: "@",
            list: "<",
            maxResults: "<",
            loading: "<"
        };

        this.controller = ListogramComponentController;
        this.template = require("./listogram.html");
    }
}
